export default "__VITE_ASSET__DxpJ6Edr__"